/**
 * @author mi
 * @date 2019/6/14
 * @project zujuanzaixian
 */

export const zujuanRouter = [
  {
    path: '/znzj',
    name: 'ZNZJ',
    component: () => import('../views/zhineng-zujuan'),
    meta: { title: '智能组卷' }
  },
  {
    path: '/mbzj',
    name: 'MBZJ',
    component: () => import('../views/moban-zujuan'),
    meta: { title: '模版组卷' }
  },
  {
    path: '/mbzj/edit',
    name: 'EditTpl',
    component: () => import('../views/moban-edit'),
    meta: { title: '编辑模板', prevRouter: { name: 'MBZJ', title: '模板组卷' }, auth: true }
  },
  {
    path: '/kdzj',
    name: 'KDZJ',
    component: () => import('../views/kaodian-zujuan'),
    meta: { title: '考点组卷' }
  },
  {
    path: '/zjzj',
    name: 'ZJZJ',
    component: () => import('../views/zhangjie-zujuan'),
    meta: { title: '章节组卷' }
  },
  {
    path: '/mxmj',
    name: 'MXMJ',
    component: () => import('../views/mingxiaomingjuan'),
    meta: { title: '名校名卷' }
  },
  {
    path: '/dailypaper',
    name: 'DailyPaper',
    component: () => import('../views/daily-paper'),
    meta: { title: '每日上新' }
  },
  {
    path: '/paperview',
    name: 'PaperView',
    component: () => import('../views/paper-view'),
    meta: { title: '试卷预览', auth: true }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/search'),
    meta: { title: '搜索' }
  },
  {
    path: '/paperdetail',
    name: 'PaperDetail',
    component: () => import('../views/paper-detail'),
    meta: { title: '试卷选题' }
  }
]
